module.exports = __webpack_public_path__ + "img/eye-tracking-white.b9fc18bd.svg";